The upper limit of webhook subscriptions to return from the start of the list.

Defaults to 10 if neither `first` nor `last` are specified.
Excess webhook subscriptions will be trimmed from the end of the list.

`first` and `last` cannot be specified in the same query.
